import {
  SET_USER_INFO,
  SET_DRAWER_VISIBLE,
  SET_INVOICE,
  SET_BILLING,
  SET_DATA_PAYMENT,
  SET_PLAN_ME,
  SET_PLANS,
} from "../actions/user";

const initialState = {
  personal: {
    name: "",
    id: "",
    email: "",
  },
  invoice: {},
  billing: [],
  dataPayment: [],
  drawerVisible: false,
  plan: false,
  plans:false
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_INFO:
      return { ...state, ...action.personal };
    case SET_DRAWER_VISIBLE:
      return { ...state, drawerVisible: action.visible };
    case SET_INVOICE:
      return { ...state, invoice: action.invoice };
    case SET_BILLING:
      return {
        ...state,
        billing: action.bill.map((item, index) => {
          return {
            invoice: { ...item.invoice, ...item.plan },
            payment: [...item.payment],
          };
        }),
      };
    case SET_DATA_PAYMENT:
      return { ...state, dataPayment: action.payment };
    case SET_PLAN_ME:
      return { ...state, plan: action.plan };
      case SET_PLANS:
        return { ...state, plans: action.plans };
    default:
      return state;
  }
};

export default userReducer;
